export default __webpack_public_path__ + "static/media/gallery-wip-emitter-shroud_04.1f00477c.jpg";